// https://coolors.co/222025-3e3c3f-5a5759-918d8c-c8c3bf-e4ded9-fff9f2
export const lightTheme = () => {
  const speeds = {
    ultrafast: '0.125s',
    fast: '0.25s',
    moderate: '0.33s',
    slow: '1s'
  }
  const strokes = {
    small: '1px',
    medium: '2px',
    thick: '4px',
  }
  const colors = {
    dark: '#222025',
    white: '#FFF9F2',
    reds: {
      primary: '#C10000',
      secondary: '#E08080',
      light: '#F0C0C0',
      ultralight: '#F8E0E0',
      ghost: '#FCF0F0'
    },
    ink: {
      primary: '#3E3C3F',
      secondary: '#5A5759',
      light: '#918D8C',
      ultralight: '#C8C3BF',
      ghost: '#E4DED9'
    },
  };
  colors.utility = colors.ink;
  const fontWeights = {
    body: 'normal',
    strong: 'bold'
  }
  const fontSizes = {
    body: '1rem',
    big: '1.25rem'
  };
  const fontFamilies = {
    body: 'Courier',
    heading: 'Courier'
  };

  return {
    speeds,
    strokes,
    colors,
    fontSizes,
    fontFamilies,
    fontWeights
  };
}

const lightThemeBase = lightTheme();

export const darkTheme = () => ({
  ...lightThemeBase,
  colors: {
    ...lightThemeBase.colors
    // todo: remap colors
  }
});

export const errorTheme = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    utility: theme.colors.reds
  }
});
